import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button, CardTitle, CardSubtitle, Label, Input ,Container, UncontrolledTooltip, Table} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import PostApiCall from '../../Api'
import GetApiCall from '../../GETAPI'
import Notiflix from "notiflix";
import moment from 'moment'




//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb'

//i18n
import { withNamespaces } from 'react-i18next';
import NavItem from "reactstrap/lib/NavItem";

class DailyPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountNo:'',
            accountToPay:'',
            paymentDate:'',
            paymentMode:'',
            consolidatedWeight:'',

        };
    }
    componentDidMount = () => {
        var login = localStorage.getItem("LoginDetail");
        var details = JSON.parse(login);
        // console.log(details[0])
        this.setState({
            Usertype: details[0].fld_usertype,
        });
        console.log("this.state.Usertype  " + this.state.Usertype)
        if (details[0].fld_usertype != "Admin") {
            window.location.href = "/"
        }
    }

    makePayment =()=>{
        if(this.state.accountNo==''){
            Notiflix.Notify.Failure("Enter Account Number")
        
        }else{
            PostApiCall.postRequest({
                accountno:this.state.accountNo,
                paymentdate:null,
                paymentmode:null,
                amounttopay:null,
                consolatedweight:null,
                updatedon:moment().format('lll'),
                updatedby:null
            }, "Add_monhlyOfflinePayments").then((result)=>
                result.json().then(obj => {
                if(result.status == 200 || result.status == 201){
                   
                    // console.log(obj)
                    Notiflix.Notify.Success('Payment Completed.')
                    window.location.reload()
                  
                }else
                {
                  Notiflix.Notify.Failure(obj.data)
                }
            })
            )
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                        {/* Render Breadcrumb */}
                        <Breadcrumbs title={this.props.t('OfflinePayment')} breadcrumbItem={this.props.t('Payment')} />
                    
                        <Card className="overflow-hidden">
                                <div
                                    className="maxXchange-bg-soft-pink"
                                    style={{ background: 'rgb(171, 61, 0)' }}
                                >
                                    <Row>
                                        <Col xs="6">
                                            <div className="maxXchange-text p-3">
                                                <h5 className="maxXchange-text text-white">
                                                   Offline Payment
                          </h5>
                                            </div>
                                        </Col>
                                    </Row>

                                </div>

                                <Card className="overflow-hidden">
                                    <div className="maxXchange-bg-soft-pink" style={{ background: '#dfb65c' }}>
                                        <Row>
                                            <Col xs="3">
                                                <div className="maxXchange-text p-3">
                                                    <h5 className="maxXchange-text">
                                                      Payment
                                </h5>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
 
                        
                                    <CardBody>
                                    <CardTitle>Offline Payment</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Enter the payment details related to particular account.
                                    </CardSubtitle>
                                        <AvForm className="needs-validation" >
                                            <Row>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom01">Book Number</Label>
                                                        <AvField
                                                          name="Account"
                                                          value={this.state.accountNo}
                                                          onChange={(text)=>{ 
                                                            this.setState({
                                                                accountNo : text.target.value
                                                            }) 
                                                        }}
                                                          placeholder="Enter Book Number"
                                                          type="text"
                                                          errorMessage="Enter Valid Book Number"
                                                          className="form-control"
                                                          validate={{ required: { value: true } }}
                                                          id="validationCustom01"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                
                                            </Row>

                                            {/* <Row>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom03">Amount To Pay</Label>
                                                        <AvField
                                                        name="Amount"
                                                        value={this.state.accountToPay}
                                                        onChange={(text)=>{ 
                                                            this.setState({
                                                                accountToPay : text.target.value
                                                            }) 
                                                        }}
                                                        placeholder="Enter Your Amount "
                                                        type="number"
                                                        errorMessage="Enter amount to pay"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="validationCustom01"
                                                        />
                                                    </FormGroup>
                                                </Col>   
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom01">Payment Date</Label>
                                                        <AvField
                                                        name="Date"
                                                        value={this.state.paymentDate}
                                                        onChange={(text)=>{ 
                                                            this.setState({
                                                                paymentDate : text.target.value
                                                            }) 
                                                        }}
                                                        type="date"
                                                        errorMessage="Select The Payment Date "
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="validationCustom01"
                                                        />
                                                    </FormGroup>
                                                </Col>    
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom01">Payment Mode</Label>
                                                        <AvField
                                                        name="Mode"
                                                        placeholder="Enter the Mode Of Payment"
                                                        value={this.state.paymentMode}
                                                        onChange={(text)=>{ 
                                                            this.setState({
                                                                paymentMode : text.target.value
                                                            }) 
                                                        }}
                                                        type="text"
                                                        errorMessage="Enter the Payment Mode"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="validationCustom01"
                                                        />
                                                    </FormGroup>
                                                </Col>                                       
                                            </Row> */}

                                            <Row>
                                                {/*<Col md="4">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom01">Current Gold Rate</Label>
                                                        <AvField
                                                        name="GoldRate"
                                                        placeholder="Enter The Today's Gold Rate"
                                                        type="number"
                                                        errorMessage="Please enter the gold rate"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="validationCustom01"
                                                        />
                                                    </FormGroup>
        </Col> */  }
                                                {/* <Col md="4">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom01">Consolidated Weight</Label>
                                                        <AvField
                                                        name="Consolidated"
                                                        value={this.state.consolidatedWeight}
                                                        onChange={(text)=>{ 
                                                            this.setState({
                                                                consolidatedWeight : text.target.value
                                                            }) 
                                                        }}
                                                        placeholder="Consolidated Weight"
                                                        type="number"
                                                        errorMessage="Enter Consolidated Weight"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="validationCustom01"
                                                        />
                                                    </FormGroup>
                                                </Col>     */}
                                                                                    
                                            </Row>
                                                                                       
                                            <button style={{backgroundColor:'#880105', color:'#e1b761', float:"right", marginRight:"2%"}} className='btn' type="submit" onClick={this.makePayment}>Save Payment Details</button>
                                           
                                        </AvForm>
                                    </CardBody>
                                </Card>
                                </Card>
                    </Container>
                        
                </div>
          
                </React.Fragment>
        );
    }
}

export default withNamespaces()(DailyPayment);








 